/* DOWB Impulsive — mobile menu drawer: accordion sublists + top-right close button.
   Dawn's default slides sub-panels in from the right; the live claraandjune.com expands
   them in place. We attach ONE capture-phase listener on <header-drawer>. Because it sits on
   an ancestor and fires in the capture phase, it runs before Dawn's own summary/button
   listeners; stopImmediatePropagation() then prevents Dawn's slide-over behaviour, and we
   drive the native <details open> toggle ourselves (CSS handles the in-place expand). */
(function () {
  function init() {
    var drawer = document.querySelector('header-drawer');
    if (!drawer || drawer.dataset.cjAccordion) return;
    drawer.dataset.cjAccordion = '1';

    // Expand the top-level category submenus by default (the live drawer opens with them open).
    // Dawn's closeMenuDrawer() strips `open` from every nested <details> on close, so we re-apply
    // it each time the drawer opens (watching the main toggle), not just once from the markup.
    function expandDefaults() {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      var rootUl = drawer.querySelector('.menu-drawer__navigation > ul.menu-drawer__menu');
      if (!rootUl) return;
      var mode = drawer.dataset.openDefault || 'mega';
      if (mode === 'none') return;
      rootUl.querySelectorAll(':scope > li > details').forEach(function (d) {
        if (mode === 'mega' && d.dataset.mega !== 'true') return;
        d.setAttribute('open', '');
        var s = d.querySelector(':scope > summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      });
    }
    var mainDetails = drawer.querySelector('#Details-menu-drawer-container');
    if (mainDetails && window.MutationObserver) {
      new MutationObserver(function () {
        if (mainDetails.hasAttribute('open')) expandDefaults();
      }).observe(mainDetails, { attributes: true, attributeFilter: ['open'] });
    }
    expandDefaults();

    drawer.addEventListener(
      'click',
      function (event) {
        // Only restyle behaviour while the drawer layout is active (mobile/tablet).
        if (window.matchMedia('(min-width: 990px)').matches) return;

        // Top-right close (X): close the whole drawer via Dawn's own toggle for clean teardown.
        var closeBtn = event.target.closest('.cj-drawer-close');
        if (closeBtn) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var mainSummary = drawer.querySelector('#Details-menu-drawer-container > summary');
          if (mainSummary) mainSummary.click();
          return;
        }

        // Parent items with a submenu: toggle the accordion in place.
        var summary = event.target.closest('summary.menu-drawer__menu-item');
        if (summary && drawer.contains(summary)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          var details = summary.parentNode;
          var willOpen = !details.hasAttribute('open');
          if (willOpen) {
            details.setAttribute('open', '');
          } else {
            details.removeAttribute('open');
          }
          summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        }
      },
      true // capture
    );
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
